import React from "react";
import { formatCPF } from "../../../../../../../function/utilis/function";
import styles from "./GroupQuadroSocioAdministrativo.module.css";

const OPCOES_ESTADO_CIVIL = [
  { value: "S", label: "Solteiro(a)" },
  { value: "C-CPB", label: "Casado(a) - Comunhão Parcial de Bens" },
  { value: "C-CUB", label: "Casado(a) - Comunhão Universal" },
  { value: "C-PFA", label: "Casado(a) - Participação Final nos Aquestos" },
  { value: "C-SB", label: "Casado(a) - Separação de Bens" },
  { value: "D", label: "Divorciado(a)" },
  { value: "V", label: "Viúvo(a)" },
];

/** Um par rótulo/valor. Mostra um placeholder em itálico quando o dado não veio preenchido. */
function Campo({ rotulo, valor, largo }) {
  const vazio = valor === null || valor === undefined || valor === "";
  return (
    <div className={`${styles.campo} ${largo ? styles.campoLargo : ""}`}>
      <span className={styles.rotulo}>{rotulo}</span>
      <span className={vazio ? styles.valorVazio : styles.valor}>{vazio ? "Não informado" : valor}</span>
    </div>
  );
}

/** Campo booleano (Sim/Não), mostrado como badge em vez de checkbox desabilitado. */
function CampoBadge({ rotulo, valor }) {
  const indefinido = valor === null || valor === undefined;
  return (
    <div className={styles.campo}>
      <span className={styles.rotulo}>{rotulo}</span>
      <span
        className={`${styles.badge} ${
          indefinido ? styles.badgeIndefinido : valor ? styles.badgeSim : styles.badgeNao
        }`}
      >
        {indefinido ? "Não informado" : valor ? "Sim" : "Não"}
      </span>
    </div>
  );
}

export function GroupQuadroSocioAdministrativo({ info }) {
  const estadoCivilId = info.estadoCivil?.id;
  const estadoCivilLabel = OPCOES_ESTADO_CIVIL.find((opcao) => opcao.value === estadoCivilId)?.label;

  return (
    <div className={styles.painel}>
      <div className={styles.grupo}>
        <h4 className={styles.grupoTitulo}>Titular / Representante perante Receita Federal</h4>
        <div className={styles.grade}>
          <Campo rotulo="CPF" valor={info.cpfSocio ? formatCPF(info.cpfSocio) : null} />
          <Campo rotulo="Nome" valor={info.nomeSocio} largo />
          <Campo rotulo="Data Nascimento" valor={info.dataNascimento} />
          <Campo rotulo="Estado Civil" valor={estadoCivilLabel} />
          {/* "Percentual Societário" é uma porcentagem, não um valor em reais — o
              formatValueBrl original formatava como moeda por engano. */}
          <Campo rotulo="Percentual Societário" valor={info.percentualSocietario != null ? `${info.percentualSocietario}%` : null} />
          <CampoBadge rotulo="Possui mesmo endereço da empresa?" valor={info.enderecoEmpresa} />
        </div>
      </div>
    </div>
  );
}

export default GroupQuadroSocioAdministrativo;
